import { render, staticRenderFns } from "./DocumentStatus.vue?vue&type=template&id=feae6096&"
import script from "./DocumentStatus.vue?vue&type=script&lang=ts&"
export * from "./DocumentStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports